<template>
    <v-sheet color="primary darken-2" fill-height>
        <v-container fill-height>
            <v-row align="center" justify="center">
                <v-col lg="4" xl="3">
                    <v-card class="card-center" fill-height color="black" dark outlined elevation="8"
                        style="min-height:40vh">
                        <v-card-text class="pos-r">
                            <BrandLogoLoader ripple :infinite="logingIn" color="primary" />
                        </v-card-text>
                        <v-spacer />
                        <v-card-text class="py-0">
                            <h2>Ownli&trade; Partners</h2>
                        </v-card-text>
                        <v-card-text class="shrink">
                            <template v-if="!logingIn">
                                <v-btn large color="primary" class="elevation-18" to="/dashboard" v-if="authenticated">
                                    Dashboard <v-icon right>$vuetify.icons.dashboard</v-icon>
                                </v-btn>
                                <v-btn large color="primary" class="elevation-18" @click="forcedLogin"
                                    :disabled="logingIn" v-else>
                                    Login <v-icon right>$vuetify.icons.login</v-icon>
                                </v-btn>
                            </template>


                            <CountDownTimer :time="5000" color="primary" :interval="100" height="52" class="timer" show-text  v-else />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-sheet>
</template>

<script>
    import {
        mapGetters,
    } from "vuex";

    import CountDownTimer from "@/components/CountDownTimer.vue";

    export default {
        name: "Home",

        components: {
            CountDownTimer,
        },

        data() {
            return {
                logingIn: false
            }
        },

        computed: {
            ...mapGetters("auth", ["authenticated", "user","isPrimaryColorDark", "partner"]),
            ...mapGetters("appshell", ["loading"]),
        },

        methods: {
            forcedLogin() {
                this.logingIn = true;
                setTimeout(() => {
                    this.$store.dispatch("auth/login", {
                        force: true
                    });
                }, 1000);
            }
        },
    };
</script>

<style lang="css" scoped>
    .v-btn {
        min-width: 250px !important;
    }
</style>